import { ProductOption } from "./option.base";

export class InitSelectorOption extends ProductOption {

}